import { FaTools, FaRegCheckCircle } from 'react-icons/fa';
import tourEditor from '../assets/tour-editor.png';
// ─────────────────────────────────────────────────────────────────────────────
// EDITOR TOUR - the Simulation editor (LevelEditor).
//
// Voice: in-world Vision Makers briefing. You're a Stalker building a Simulation
// world other Stalkers will dive into. Use the lore vocabulary (Simulation, dive
// in, materialize, loot/Data), not invented jargon. Auto-runs the first time a
// creator opens the editor; replayable from the "Tour" button. Keep targets in
// sync with the editor UI.
//
// Targets are CSS selectors verified against the live editor:
//   .toolbar-tabs       - Map / Events / UX Panels / Art workspaces
//   .map-grid           - the grid of cells (nodes)
//   .overlay-view-block - Overlay & View plate (Types overlay, colour, opacity)
//   .zoom-block         - zoom slider / +/- controls
//   .editor-tools       - Guide / Balance / AI action cluster (top right)
//   .floating-panel     - the "Level checklist" panel
// A missing target degrades to a centered card, so the tour never breaks.
// ─────────────────────────────────────────────────────────────────────────────
export const EDITOR_TOUR = {
    id: 'editor',
    seenKey: 'vm-editor-tutorial-seen',
    steps: [
        {
            id: 'editor-welcome',
            kind: 'intro',
            icon: FaTools,
            image: tourEditor,
            title: 'Building the Simulation',
            body: 'This is where the world takes shape - the terrain, the obstacles, the loot. Quick briefing before you start.',
        },
        {
            id: 'editor-tabs',
            kind: 'spotlight',
            screen: 'editor',
            target: '.toolbar-tabs',
            placement: 'bottom',
            title: 'Workspaces',
            body: "Map is where you build the world. Events, UX Panels and Art layer in deeper content. You'll spend most of your time on Map.",
        },
        {
            id: 'editor-map',
            kind: 'spotlight',
            screen: 'editor',
            target: '.map-grid',
            placement: 'auto',
            title: 'The world - shape each node',
            body: "Every cell is a node - one place in the Simulation. Select a cell, then set its type, status, locks and loot in the panel that opens on the right. That's how you shape what a Stalker faces when they dive in.",
        },
        {
            id: 'editor-overlays',
            kind: 'spotlight',
            screen: 'editor',
            target: '.overlay-view-block',
            placement: 'bottom',
            title: 'Overlays',
            body: "Switch on Types to read each cell's node type right on the map. You can tune the overlay colour, opacity and grid lines from here too.",
        },
        {
            id: 'editor-zoom',
            kind: 'spotlight',
            screen: 'editor',
            target: '.zoom-block',
            placement: 'bottom',
            title: 'Zoom & pan',
            body: 'Zoom with the slider or the +/- buttons, and drag the canvas to move across larger worlds.',
        },
        {
            id: 'editor-tools',
            kind: 'spotlight',
            screen: 'editor',
            target: '.editor-tools',
            placement: 'bottom',
            title: 'Story, balance & checklist',
            body: 'Balance auto-distributes Data & resources to your targets, and Guide reopens the checklist. Next to them sits the Image Generator.',
        },
        {
            id: 'editor-ai',
            kind: 'spotlight',
            screen: 'editor',
            target: '.ai-gen-trigger',
            placement: 'bottom',
            title: 'The Image Generator',
            body: "Once your story is approved, open the Image Generator - it walks the cover, every obstacle and every UX panel, one image at a time, until the level's art is done.",
        },
        {
            id: 'editor-checklist',
            kind: 'spotlight',
            screen: 'editor',
            target: '.floating-panel',
            placement: 'auto',
            title: 'Level checklist',
            body: "Tracks what's left before review - name, obstacles, a Start cell, distribution - and hands you the Submit button once the Simulation is ready.",
        },
        {
            id: 'editor-done',
            kind: 'intro',
            icon: FaRegCheckCircle,
            title: 'The world is yours',
            body: 'Seed the obstacles, mark where Stalkers materialize, distribute the loot, then submit for review. You can replay this briefing anytime from the Tour button in the toolbar.',
        },
    ],
};
